import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxIconName } from '@onyx/angular';
import {
  OnyxAvatarComponent,
  OnyxDataWidgetComponent,
  OnyxIconButtonComponent,
  OnyxIconComponent,
  OnyxInformationHeadingComponent,
  OnyxNamePipe,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { Delegation } from '../../../dashboard/delegations/common/interfaces/delegation';
import { DriverHelper } from '../../../dashboard/drivers/common/helpers/driver.helper';
import type { SimplifiedDriver } from '../../../dashboard/drivers/common/interfaces/driver';
import type { FleetCategory } from '../../../dashboard/fleet/common/enums/fleet-category';
import { FleetHelper } from '../../../dashboard/fleet/common/helpers/fleet.helper';
import type { SimplifiedFleet } from '../../../dashboard/fleet/common/interfaces/fleet';
import { OrderModalHelper } from '../../../dashboard/orders/common/helpers/order-modal.helper';
import type { Order } from '../../../dashboard/orders/common/interfaces/order';
import { FleetIdentifierPipe } from '../../pipes/fleet-identifier.pipe';
import { ModuleLinkComponent } from '../module-link/module-link.component';

@Component({
  selector: 'app-modal-realized-by',
  imports: [
    ModuleLinkComponent,
    OnyxDataWidgetComponent,
    FleetIdentifierPipe,
    TranslatePipe,
    OnyxNamePipe,
    OnyxInformationHeadingComponent,
    OnyxIconComponent,
    OnyxAvatarComponent,
    OnyxIconButtonComponent,
    OnyxTooltipDirective,
    NgTemplateOutlet,
  ],
  templateUrl: './modal-realized-by.component.html',
  styleUrl: './modal-realized-by.component.scss',
})
export class ModalRealizedByComponent {
  private readonly fleetHelper = inject(FleetHelper);
  private readonly driverHelper = inject(DriverHelper);
  private readonly orderModalHelper = inject(OrderModalHelper);

  public readonly order = input<Order>();
  public readonly delegation = input<Delegation>();

  protected readonly I18N = 'orders.orderModal';

  protected vehicle = computed(
    () => this.order()?.assignedData?.vehicle ?? this.delegation()?.vehicle,
  );
  protected trailer = computed(
    () => this.order()?.assignedData?.trailer ?? this.delegation()?.trailer,
  );
  protected primaryDriver = computed(
    () =>
      this.order()?.assignedData?.primaryDriver ??
      this.delegation()?.primaryDriver,
  );
  protected secondaryDriver = computed(
    () =>
      this.order()?.assignedData?.secondaryDriver ??
      this.delegation()?.secondaryDriver,
  );

  protected openFleetModal(fleet: SimplifiedFleet): void {
    this.fleetHelper.openModal(fleet);
  }

  protected openDriverModal(driver: SimplifiedDriver): void {
    this.driverHelper.openModal(driver);
  }

  protected openActivityModal(): void {
    this.orderModalHelper.openActivityModal({
      order: this.order(),
      delegation: this.delegation(),
    });
  }

  protected getFleetIcon(category: FleetCategory): OnyxIconName {
    return `${category}-filled`;
  }
}
